import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import styles from '../styles/configuration.module.scss';
import ConfigurationsFooter from '../components/configurationsFooter';
import { regexp } from '../helpers/validations';

function SecondStep({ configs, changeStep, className, language }) {
    const { t } = useTranslation('configuration');

    const [form, setForm] = useState({
        name: '',
        email: '',
        company: ''
    });

    const [validations, setValidations] = useState({
        name: '',
        email: '',
        phone: '',
        comment: ''
    });

    const [privacy, setPrivacy] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prevState => ({ ...prevState, [name]: value }));
        setValidations(prevState => ({ ...prevState, [name]: (regexp[name] || regexp.comment).test(value) }));
    };

    const isFill = validations.name && validations.email && privacy;

    const submit = () => {
        const h = new Headers();
        h.append('Content-Type', 'application/json');
        fetch(`${process.env.API_URL}/configuration`, {
            method: 'POST',
            body: JSON.stringify({
                user: { ...form, language },
                services: configs
            }),
            headers: h
        }).then(res => {
            if (res.status.toString()[0] === '2') {
                changeStep(1, true);
            } else {
                changeStep(1, false);
            }
            setForm({
                name: '',
                email: '',
                company: ''
            });
        })
            .catch(_e => {
                setForm({
                    name: '',
                    email: '',
                    company: ''
                });
                changeStep(1, false);
            });
    };

    return <div className={className || styles.second}>
        <img src='/step2.webp' alt='Background' className='main__img' />
        <div className={styles['contact-form']}>
            <h2>{t('title')}</h2>
            <h3>{t('contactInfo')}</h3>
            {
                ['name', 'email', 'company'].map(field => (
                    <label key={field}>
                        {t(field)}
                        <input type='text'
                            name={field}
                            value={form[field]}
                            onChange={handleChange}
                            className={!form[field] || validations[field] ? '' : 'invalid'} />
                    </label>)
                )
            }
            <div className={styles.agreement}>
                <input type="checkbox" id="agreement" className='pointer' checked={privacy} onChange={() => setPrivacy(prevState => !prevState)} />
                <label htmlFor="agreement" dangerouslySetInnerHTML={{ __html: t('agree', { interpolation: { escapeValue: false } }) }} />
            </div>

            <div>
                <button className={'btn ' + styles.back} onClick={() => changeStep(-1, true)}>{t('back')}</button>
                <button className='btn cloud' disabled={!isFill} onClick={submit}>{t('submit')}</button>
            </div>
        </div>
        <ConfigurationsFooter />
        <style jsx>{`
            input[type='text'].invalid {
                color: red;
                border: 0.5px solid red;
            }

            .btn.cloud:disabled {
                cursor: initial;
                background: grey;
            }
        `}</style>
    </div>
};

export default memo(SecondStep);
